import { render, staticRenderFns } from "./eventDetails.vue?vue&type=template&id=1a4f5c39"
import script from "./eventDetails.vue?vue&type=script&lang=js"
export * from "./eventDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports